module.exports = __webpack_public_path__ + "img/marker_six_yellow1.273ccef6.png";